<template>
    <v-form-group
        :label="label"
        :description="description"
        :error="error"
        :state="errorState">
        <v-multiselect
            v-model='input'
            @input="handleInput"
            label="full_name"
            track-by="id"
            placeholder="Type to search"
            open-direction="bottom"
            :options="options"
            :multiple="false"
            :optionsLimit="readonly ? 0 : 1000"
            :searchable="true"
            :loading="loading"
            :internal-search="false"
            :clear-on-select="false"
            :close-on-select="true"
            :options-limit="300"
            :limit="10"
            :limit-text="limitText"
            :max-height="600"
            :show-no-results="false"
            :hide-selected="false"
            :allow-empty="true"
            deselect-label="Remove"
            @search-change="search">
            <template
                slot="clear"
                slot-scope="props">
                <div class="multiselect__clear"
                     v-if="options.length"
                     @mousedown.prevent.stop="clearAll(props.search)"></div>
            </template>
            <span slot="noResult">Oops! No speakers found. Consider changing the search query.</span>
        </v-multiselect>
    </v-form-group>
</template>

<script>
    import axios from 'axios'
    import Field from '../../Mixins/field'
    import qs from 'qs'

    export default {
        mixins: [Field],
        props: ['value'],
        data()
        {
            return {
                loading: false,
                options: []
            }
        },
        created()
        {
            this.search()
        },
        methods: {
            limitText(count)
            {
                return `and ${count} other speakers`
            },
            async search(filter = '')
            {
                try {
                    let {data: results} = await axios.get('/api/speakers', {
                        params: {
                            filter: {'search' : filter},
                            per_page: 10
                        },
                        paramsSerializer: function(params) {
                            return qs.stringify(params, {arrayFormat: 'repeat'})
                        }
                    })

                    this.options = results.data
                    this.loading = false
                } catch (ex) {
                    alert(ex)
                    this.loading = false
                }

            }
        }
    }
</script>
